import * as React from 'react';
import { CardHeader, Grid, Box, NativeSelect, FormControl, Card, Tooltip, Typography, TooltipProps, tooltipClasses } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useSelector } from 'src/reducers';
import { styled } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import {
  ZoomableGroup,
  ComposableMap,
  Geographies,
  Geography
} from "react-simple-maps";
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong';
import { DashboardGeoDataRequest } from 'src/actions/dashboardActions';
const shadow_custom_world_map = "shadow-md";
import geoUrl from "./country_data.json"
import { color as colorJson } from "./color"
import useId from '@mui/utils/useId';
import { KeyboardAltOutlined } from '@mui/icons-material';
import ReactCountryFlag from 'react-country-flag';


export default function DashboardProjectGeoSection() {

  const [filter, setFilter] = useState<any>({ type: 1 });

  const dispatch = useDispatch();
  const dashboardData = useSelector(state => state.dashboard);
 const { loading, dashboardProjectGeoSectionData } = dashboardData;


//   const dashboardProjectGeoSectionData =[
//     {
//         "_id": "62151c9cca53f1138fab528e",
//         "countryCode": "US",
//         "countryName": "United States",
//         "traffic": 259,
//         "complete": 8,
//         "mobile": 1,
//         "tablet": 0,
//         "desktop": 258,
//         "approved": 0,
//         "security": 218,
//         "country": "62151c9cca53f1138fab528e"
//     },
//     {
//         "_id": "62151c9cca53f1138fab528d",
//         "countryCode": "GB",
//         "countryName": "United Kingdom",
//         "traffic": 41,
//         "complete": 1,
//         "mobile": 0,
//         "tablet": 0,
//         "desktop": 41,
//         "approved": 0,
//         "security": 33,
//         "country": "62151c9cca53f1138fab528d"
//     },
//     {
//         "_id": "62151c9cca53f1138fab51f9",
//         "countryCode": "DE",
//         "countryName": "Germany",
//         "traffic": 31,
//         "complete": 0,
//         "mobile": 0,
//         "tablet": 0,
//         "desktop": 31,
//         "approved": 0,
//         "security": 10,
//         "country": "62151c9cca53f1138fab51f9"
//     },
//     {
//         "_id": "62151c9cca53f1138fab520d",
//         "countryCode": "IN",
//         "countryName": "India",
//         "traffic": 10,
//         "complete": 2,
//         "mobile": 0,
//         "tablet": 0,
//         "desktop": 10,
//         "approved": 0,
//         "security": 1,
//         "country": "62151c9cca53f1138fab520d"
//     },
//     {
//         "_id": "62151c9cca53f1138fab5216",
//         "countryCode": "JP",
//         "countryName": "Japan",
//         "traffic": 8,
//         "complete": 0,
//         "mobile": 0,
//         "tablet": 0,
//         "desktop": 8,
//         "approved": 0,
//         "security": 8,
//         "country": "62151c9cca53f1138fab5216"
//     },
//     {
//         "_id": "62151c9cca53f1138fab51f2",
//         "countryCode": "FR",
//         "countryName": "France",
//         "traffic": 6,
//         "complete": 0,
//         "mobile": 0,
//         "tablet": 0,
//         "desktop": 6,
//         "approved": 0,
//         "security": 6,
//         "country": "62151c9cca53f1138fab51f2"
//     }
// ]

  const columns = [
    { field: 'countryName', type: "string", headerName: 'Country', filterable: false, flex: 1, headerAlign: "left", align: 'left' },
    { field: 'traffic', type: "string", headerName: 'Traffic', filterable: false, width: 100, headerAlign: "center", align: 'center' },
  ];

  useEffect(() => {
    dispatch(DashboardGeoDataRequest(filter))
  }, [filter])

  // let tooltip = useRef<TooltipRefProps>(null);

  const [position, setPosition] = useState<{
    coordinates: [number, number];
    zoom: number;
  }>({
    coordinates: [81, 13],
    zoom: 0,
  });

  const handleZoomIn = () => {
    if (position.zoom >= 4) return;
    setPosition((prev) => ({ ...prev, zoom: prev.zoom + 0.5 }));
  };

  const handleZoomOut = () => {
    if (position.zoom <= 1) return;
    setPosition((prev) => ({ ...prev, zoom: prev.zoom - 0.5 }));
  };

  const handleCenter = () => {
    setPosition({ zoom: 1.75, coordinates: [81, 13] });
  };

  const handleMoveEnd = (position: {
    coordinates: [number, number];
    zoom: number;
  }) => {
    setPosition(position);
  };

  const id = useId();


  const fillColor = (geo: any,key:number) => {
    const country = dashboardProjectGeoSectionData.find((d: any) => d.countryName === geo.properties.name);
    if (country && colorJson[key]) {
      return colorJson[key].hex
    }
    else if(country && !colorJson[key]){
      return colorJson[Math.round(key/2)].hex
    }
    return "#D6D6DA";
  };

    const getCountryTraffic = (properties_name:any) => {
        const country = dashboardProjectGeoSectionData.find((d:any) => d.countryName == properties_name);
        if(country && country.traffic) return country.traffic
        return 0;
  };

  

  const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
  }));


  return (
    <Grid item xs={12} md={12} lg={12}>
      <Card>
        <CardHeader title="Countries" subheader=""
          action={
            <Box>
              {filter && <FormControl variant="outlined" sx={{ mr: 2 }} >
                <NativeSelect
                  variant="outlined"
                  onChange={(e) => setFilter({ 'type': e.target.value })}
                  defaultValue={1}
                >
                  <option value={1}>Daily</option>
                  <option value={2}>Monthly</option>
                  <option value={3}>Yearly</option>
                </NativeSelect>
              </FormControl>}
            </Box>
          } />
        <Box sx={{ display: "flex", justifyContent: 'center', alignItems: 'center' }}>
          <Grid item xs={12} md={10} lg={10} style={{marginTop:'20'}}>
            <div className="relative" >
              <ComposableMap projection="geoMercator">
                <ZoomableGroup
                style={{marginTop:'20'}}
                  zoom={position.zoom}
                  center={position.coordinates}
                  onMoveEnd={handleMoveEnd}
                >
                  <Geographies geography={geoUrl}>
                    {({ geographies }) =>
                      geographies.map((geo,key) => {
                        return (
                          <HtmlTooltip
                            key={geo.rsmKey}
                            title={
                              <React.Fragment>
                                <div className="flex gap-x-5">
                                  <div className="flex justify-center items-center">
                                    <p className="font-primary-Regular font-bold ">{geo.properties.name}</p>
                                  </div>
                                  <div>
                                    <small className=" font-primary-Regular  ">Active Users</small>
                                    <p className="text-sm font-primary-Regular">{getCountryTraffic(geo.properties.name)}</p>
                                  </div>
                                </div>
                              </React.Fragment>
                            }
                          >
                            <Geography
                              geography={geo}
                              onMouseEnter={() => {
                                document.body.classList.add("target");
                              }}
                              onMouseLeave={() => {
                                document.body.classList.remove("target");
                              }}
                              fill={geo.properties.color}
                              style={{
                                default: {
                                  fill: fillColor(geo,key),
                                  outline: "none"
                                },
                                hover: {
                                  fill: fillColor(geo,key),
                                  outline: "none"
                                },
                                pressed: {
                                  fill: "#E42",
                                  outline: "none"
                                }
                              }}
                              className="focus:outline-none"
                              data-tooltip-id={id}
                            />
                          </HtmlTooltip>
                        );
                      })
                    }
                  </Geographies>
                </ZoomableGroup>
              </ComposableMap>

              {/* Tooltip💡 */}
              {/* Zoom in-out 🔍🔎 */}
              <div className="absolute right-0 bottom-0">
                <div
                  className={`bg-white rounded-lg p-2 mx-3 my-1 ${shadow_custom_world_map}`}
                >
                  {/* <button
                    className="block p-1 pb-2"
                    title="zoom in"
                    type="button"
                    onClick={handleZoomIn}
                  > */}
                     {/* <ZoomInIcon   onClick={handleZoomIn} /> */}
                  {/* </button> */}
                  {/* <button
                    className="block p-1 pt-2"
                    title="zoom out"
                    type="button"
                    onClick={handleZoomOut}
                  > */}
                     {/* <ZoomOutIcon /> */}
                  {/* </button> */}
                </div>
{/* 
                <button
                  title="center"
                  type="button"
                  onClick={handleCenter}
                  className={`p-3 mx-3 mt-1 mb-2 bg-white rounded-lg float-right ${shadow_custom_world_map}`}
                > */}
                 {/* <CenterFocusStrongIcon/> */}
                {/* </button> */}
              </div>
              <div
                className={`absolute right-0 bottom-0 left-0 bg-white rounded-2xl p-2 m-3 flex flex-wrap items-center justify-center text-gray-900 dark:text-white`}
              >
                {dashboardProjectGeoSectionData.map(({ countryName,countryCode }: any) => {
                  return (
                    <Box style={{marginRight:20}} key={countryName}>
                      <ReactCountryFlag className="emojiFlag" countryCode={`${countryCode}`} />
                      <span className="text-sm ml-1">{countryName}</span>
                      <span className="text-sm ml-1 font-bold">{getCountryTraffic(countryName)}</span>
                    </Box>
                  );
                })}
              </div>
            </div>
          </Grid>
          {/* <Grid item xs={5} md={5} lg={5}>
            <DataGridRender
              height={600}
              filterTypes={['export']}
              exportFileName={"Geos"}
              filters={filters}
              data={dashboardProjectGeoSectionData}
              limit={limit}
              loading={loading}
              search={search}
              pageNo={pageNo}
              columns={columns}
              setPageNo={setPageNo}
              setSearch={setSearch}
              setLimit={setLimit}
              setFilters={setFilters}
              hideFooterPagination={true}
            />
          </Grid> */}
        </Box>
      </Card>
    </Grid>
  );
}
